import { useJsApiLoader } from '@react-google-maps/api';
const libraries = ['places', "geometry", "drawing"]
const useGoogleMapsLoader = () => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: libraries,
        language: 'ar',
        region: 'EG',
        version: "3"
    });

    return { isLoaded };
};
export default useGoogleMapsLoader;